import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateDraftEmployeeBasicsStepInput,
  PayrollUpdateDraftEmployeeBasicsGraphQLRequest,
  PayrollUpdateDraftEmployeeBasicsStepResponse,
} from '../types';

const payrollUpdateDraftEmployeeBasicsMutation = gql`
  mutation PayrollUpdateDraftEmployeeBasics(
    $draftEmployeeId: Int!
    $input: PayrollUpdateDraftEmployeeBasicsStepInput!
  ) {
    payrollUpdateDraftEmployeeBasics(draftEmployeeId: $draftEmployeeId, input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const updateDraftEmployeeBasicsStep = (payload: {
  draftEmployeeId: number;
  input: PayrollUpdateDraftEmployeeBasicsStepInput;
}) => {
  return graphQLApi<PayrollUpdateDraftEmployeeBasicsStepResponse, PayrollUpdateDraftEmployeeBasicsGraphQLRequest>({
    query: payrollUpdateDraftEmployeeBasicsMutation,
    queryVariables: payload,
  });
};
